import { render, staticRenderFns } from "./ContentImportMetadata.vue?vue&type=template&id=279a3d04&"
import script from "./ContentImportMetadata.vue?vue&type=script&lang=ts&"
export * from "./ContentImportMetadata.vue?vue&type=script&lang=ts&"
import style0 from "./ContentImportMetadata.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports